import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Button } from '@mui/material';
import NewProductForm from "../components/NewProductForm.js"
import axios from "axios";
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProductsPage = () => {

  let [selectedRow, setSelectedRow] = useState(null);
  let [selectedRowData, setSelectedRowData] = useState(null);
  const [isNewProductFormOpen, setIsNewProductFormOpen] = useState(false);

  const openNewProductForm = () => {
    setIsNewProductFormOpen(true);
    setSelectedRowData(null);
  };

  // Function to close the form
  const closeNewProductForm = () => {
    setIsNewProductFormOpen(false);
  };

  const { userRole } = useAuth()
  const [employee, setEmployee]= useState(true);

  useEffect (()=>{
    if (userRole === "manager") {
      setEmployee(false)
    } else{
      setEmployee(true)
    };
  },[userRole])

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/products/all_products`)
        const responseData = await response.json();
        setData(responseData.product);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchAllProducts();
  }, [isNewProductFormOpen])

  const delete_product = async (selectedRowId) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/products/delete_product`, {
        data:{
          id:selectedRowId
        }
      })
      if(response.status===200)
      {
        toast.success(`Product with id: "${selectedRowId}" deleted successfully.`)
      }
    } catch (error) {
      toast.error("Error deleting Product")
    }
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: 'product_name', //access nested data with dot notation
        header: 'Product name',
        size: 100,
      }
    ],
    [],
  );

  return (
    <>
      <StickyTitle title="Products" button_action={openNewProductForm} button="New Product" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className='px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
        
      <div className="table-filters flex flex-row items-center justify-between mt-3 ">
        <div className='text-2xl ml-5 font-bold font-poppins'>All Products</div>
      </div>

      <div className="w-full">
        <MaterialReactTable
          // enableRowActions
          enableRowSelection
          columns={columns}
          data={data}
          renderTopToolbarCustomActions={({ table }) => {
            const handleDelete = () => {
              const selectedRows = table.getSelectedRowModel().flatRows;

              if (selectedRows.length === 1) {
                selectedRow = selectedRows[0];
                const selectedRowId = selectedRow.original.id;
                setSelectedRow(selectedRow);
                alert('Deleting Product with ID: ' + selectedRowId);
                delete_product(selectedRowId)
              } else {
                alert('Please select a single row to delete.');
              }
            };
            const handleEdit = () => {
              const selectedRows = table.getSelectedRowModel().flatRows;

              if (selectedRows.length === 1) {
                const selectedRow = selectedRows[0];
                selectedRowData = selectedRow.original;
                setSelectedRowData(selectedRowData);
                setIsNewProductFormOpen(true);
              } else {
                alert('Please select a single row to Edit.');
              }
            };


            return (
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <Button
                  color="error"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleDelete}
                  variant="contained"
                  sx={employee ? {display: 'none'} : { }}

                >
                  Delete
                </Button>
                <Button
                  color="success"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleEdit}
                  variant="contained"
                >
                  Edit
                </Button>
                <Button
                  color="success"
                  variant="contained"
                >
                  <CSVLink data={data}>Export to CSV</CSVLink>
                </Button>
              </div>
            );
          }}
        />
      </div>
      </div>


      <NewProductForm isOpen={isNewProductFormOpen} onClose={closeNewProductForm} selectedRowData={selectedRowData} />
    </>
  );
};

export default ProductsPage;
